<template>
  <div class="dbc-gl-page">
    <TheHeader v-if="hasHeaderAndFooter()" :page="page" :logo="config.logo" />
    <div class="dbc-gl-content bg-gray grow">
      <div class="dbc-gl-section">
        <div class="ml-s mt-s w-full max-tablet:ml-0 max-tablet:mt-xs">
          <slot />
        </div>
      </div>
    </div>
    <TheFooter v-if="hasHeaderAndFooter()" />
  </div>
</template>

<script setup lang="ts">
const page = useAttrs().page as Page
const config = inject('configuration') as Ref<Config>
</script>
